import React, { useRef } from "react";
import Modal from "react-modal";
import ReceiptComponent from "../RecepitComponent";
import { convertAmountToWords } from "../../utils/ConvertToWords";
import { FaDownload } from "react-icons/fa";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import MedicineReceiptComponent from "../MedicineRecepitComponent";
import { formatDateTime } from "../../utils/FormatDateTime";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "95%", // Responsive for mobile
    zIndex: 1050,
    padding: "20px",
  },
  overlay: {
    zIndex: 1040,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
};

Modal.setAppElement("#root");

const ViewMedicinePdfModalFromComponent = ({ isOpen, onRequestClose, contentLabel, values }) => {


  const receiptRef = useRef();

  const downloadPdf = async (values) => {
    const element = receiptRef.current;

    // Use html2canvas to capture the component
    const canvas = await html2canvas(element, { scale: 2 }); // Higher scale for better quality
    const imgData = canvas.toDataURL('image/png'); // Convert canvas to image data

    // Create a PDF using jsPDF
    const pdf = new jsPDF('p', 'mm', 'a5');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(values.name);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel={contentLabel}
    >
      <div>
        <div ref={receiptRef}>
          <MedicineReceiptComponent
            name={values.name || "N/A"}
            amount={values.amount || 0}
            paymentMode={values.mode || "N/A"}
            receiptNo={Math.floor(Math.random() * 10000)}
            phonePayNo={values.phone || "N/A"}
            medicines={values.medicines}
            packageType={values.package_type}
            date={formatDateTime(values.created_at)}
            amountInWords={
              values.amount
                ? `${convertAmountToWords(values.amount)}`
                : "Zero Only"
            }
          />
        </div>
        <div className="mt-4 cursor-pointer flex flex-row gap-2 items-center text-blue-700 font-bold" onClick={() => downloadPdf(values)}>
          <span><FaDownload color='blue' size={15} /></span>
          Download
        </div>
      </div>
    </Modal>
  );
};

export default ViewMedicinePdfModalFromComponent;
